import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row" }
const _hoisted_2 = { class: "text-xl font-semibold" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "mt-10 space-y-4 md:space-y-0 md:mt-0 md:ml-auto md:px-4 md:items-center justify-center flex flex-col lg:flex-row" }
const _hoisted_5 = { class: "bg-Third w-56 py-2 rounded flex flex-row" }
const _hoisted_6 = {
  key: 0,
  class: "mx-auto h-5 w-5 animate-spin text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "mx-auto"
}
const _hoisted_11 = {
  key: 2,
  class: "mx-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.name), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", _hoisted_5, [
        (_ctx.buttonActive)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_9))
          : _createCommentVNode("", true),
        (!_ctx.cancel_at_end)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Renews on " + _toDisplayString(_ctx.renewal_date), 1))
          : (_ctx.cancel_at_end)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Ends on " + _toDisplayString(_ctx.renewal_date), 1))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}